<template>
  <div class="admin-settings">
    <div class="panelheader border-4">
      <div class="title">{{pageName}}</div>
    </div>

    
    <div class="settings">
      <el-table
        :data="settings"
        empty-text="No Settings Found"
        style="width: 100%">

        <el-table-column
          label="Name"
          header-align="center">
          <template slot-scope="props">
            <span v-if="newRow && (!props.row.name || !props.row.value)">
              <el-input v-model="props.row.name" :placeholder="props.row.name" @keyup.enter.native="editSetting(props.row)" @keydown.tab.native="editSetting(props.row)"></el-input>
            </span>
            <span v-else>
              {{props.row.name}}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          label="Value"
          header-align="center">
          <template slot-scope="props">
            <span v-if="editingRow == props.row.name">
              <el-input autofocus v-model="props.row.value" :placeholder="props.row.value" @keyup.enter.native="editSetting(props.row)" @keydown.tab.native="editSetting(props.row)"></el-input>
            </span>
            <span v-else>
              {{props.row.value}}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="userIsSuperAdmin"
          label="Operations"
          align="center">
            <template slot-scope="props">
              <span v-if="!props.row.name">
                <el-tooltip class="op-tooltip" effect="dark" content="New" placement="top" :enterable="false">
                  <button class="ui icon button more-btn"
                    @click="enableNewRow(props.row)">
                    <i class="plus icon"></i>
                  </button>
                </el-tooltip>
              </span>
              <span v-else-if="editingRow != props.row.name">
                <el-tooltip class="op-tooltip" effect="dark" content="Edit" placement="top" :enterable="false">
                  <button class="ui icon button edit-btn"
                    @click="editSetting(props.row)">
                    <i class="edit icon"></i>
                  </button>
                </el-tooltip>
              </span>
              <span v-else>
                <el-tooltip class="op-tooltip" effect="dark" content="Confirm" placement="top" :enterable="false">
                  <button class="ui icon button confirm-btn"
                    @click="editSetting(props.row)">
                    <i class="check icon"></i>
                  </button>
                </el-tooltip>
              </span>
            </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
import requests from '../../requests'
import auth from '../../auth'
import operations from './OpButtons.vue';


export default {
  name: 'admin-settings',
  data () {
    return {
      pageName: 'Global Settings',
      settings: [],
      startSettings: [],
      userIsSuperAdmin: false,
      editingRow: -1,
      newRow: false,
    }
  },
  beforeMount() {
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role == 3);

    var context = this;
    requests.getGlobals(this, function(result) {
      var data = result.data;
      for(var name in data) {
        if(name == 'enforce_one_row')
          continue
        var value = data[name];
        context.settings.push({name, value})
      }
      context.settings.push({name: '', value: ''})
      context.startSettings = context.settings.slice();
    })
  },
  methods: {
    editSetting(row){
      if(this.editingRow == row.name) {
        this.editingRow = -1;
      } else {
        this.editingRow = row.name;
      }

      for(var i in this.settings){
        var val = this.settings[i];
        if(!val.name && !val.value) {} 
        else if(!val.name || !val.value) {
          return
        }
      }

      var context = this;
      var doNewSetting = new Promise((resolve, reject) => {
        // Remove all empty
        var d, d2;
        do { d = context.settings.pop() } while (!d.name);
        do { d2 = context.startSettings.pop() } while (!d2.name);
        context.settings.push(d); context.startSettings.push(d2);


        if(context.settings.length > context.startSettings.length) { //New setting

          if(context.startSettings.filter(v => v.name == d.name).length > 1) {
            reject("Something went wrong with the new setting. Try again.");
          }

          var data = {
            col_name: d.name,
            default: d.value,
          }

          requests.newGlobal(context, data, function(result){
            if(result.action == "success")
              resolve(true)
            else
              reject(result.msg)
          })

        } else {
          resolve(true)
        }
      })

      doNewSetting.then((val) => {
        if(!val) {
          context.$message({
            'showClose': true,
            'type': 'error',
            'message': "This message should never show. Something went horribly wrong."
          })
          return     
        }

        if(JSON.stringify(this.settings) != JSON.stringify(this.startSettings)) {
          var data = {}
          for(var i in this.settings) {
            var val = this.settings[i];
            data[val.name] = val.value
          }

          requests.updateGlobals(this, data, function(result) {
            if(result.action == 'success') {
              if(context.newRow) {
                context.newRow = false;
              }
              context.startSettings = context.settings.slice();
            } else {
              context.$message({
                'showClose': true,
                'type': 'error',
                'message': result.msg
              });
            }
            if(context.settings.slice(-1).name != '') {
                context.settings.push({name: '', value: ''})              
            }
          }) 
        }

        

      }).catch((err) => {
        context.$message({
          'showClose': true,
          'type': 'error',
          'message': err
        });
      });
      
    },
    enableNewRow(row){
      this.newRow = !this.newRow;
      // this.settings.push({name: '', value: ''})      
    },
  },
  components: {
    'operations': operations
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Settings.vue?27d107ee